import { useContext } from 'react';
import { type MixpanelContext, mixpanelContext } from './mixpanelContext';

export const useMixpanel = (): MixpanelContext => useContext(mixpanelContext);
